import { Observable, throwError } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { SnackbarService } from '@siemens/component-lib';
import { AppError } from '../errors/app.error';

@Injectable({
    providedIn: 'root'
})
export class ErrorService {
    private snackbarService = inject(SnackbarService);

    public handleError<T>(operation?: string): (error: Error) => Observable<T> {
        return (error: Error): Observable<T> => {
            this.snackbarService.open({
                title: `Error: ${operation}`,
                description: `${error?.name}`,
                type: 'error',
                duration: 50000,
                position: 'bottom-right'
            });
            return throwError(() => new AppError(error?.message));
        };
    }

    public handleSuccess<T>(operation?: string): (result: T) => Observable<T> {
        return (result: T): Observable<T> => {
            this.snackbarService.open({
                title: `Success: ${operation}`,
                description: 'Operation completed successfully.',
                type: 'success',
                duration: 5000,
                position: 'bottom-right'
            });
            return new Observable<T>(observer => {
                observer.next(result);
                observer.complete();
            });
        };
    }
}
